
import { Switch } from "@/components/ui/switch";

interface UserStatusToggleProps {
  userId: string;
  isActive: boolean;
  onStatusChange: (userId: string, isActive: boolean) => Promise<void>;
}

export function UserStatusToggle({ userId, isActive, onStatusChange }: UserStatusToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch 
        checked={isActive} 
        onCheckedChange={(checked) => onStatusChange(userId, checked)}
        aria-label={`${isActive ? 'Deactivate' : 'Activate'} user account`}
        className="data-[state=checked]:bg-accent"
      />
      <span className="text-sm text-muted-foreground font-caption font-light">
        {isActive ? 'Active' : 'Inactive'}
      </span>
    </div>
  );
}
